// extracted by mini-css-extract-plugin
var _1 = "_4uypS__diceBetInfo";
var _2 = "_4uypS__diceBetInfo__betNum";
var _3 = "_4uypS__diceBetInfo__resultEntry";
var _4 = "_4uypS__diceBetInfo__resultHeader";
var _5 = "_4uypS__diceBetInfo__resultNum";
var _6 = "_4uypS__diceBetInfo__wrap";
export { _1 as "diceBetInfo", _2 as "diceBetInfo__betNum", _3 as "diceBetInfo__resultEntry", _4 as "diceBetInfo__resultHeader", _5 as "diceBetInfo__resultNum", _6 as "diceBetInfo__wrap" }
